import { POST_STATES } from "constants/PostsView";
import type { Post } from "shared/types/post";

export type ApprovalBoardPostType = "draft" | "schedule" | "queue" | "archive";

export type ApprovalBoardPost = Post & { start?: Date };

export function getApprovalBoardPostType(
  post: Pick<
    ApprovalBoardPost,
    "queued" | "postType" | "nextRunAt" | "when" | "scheduledFor" | "start"
  >
): ApprovalBoardPostType {
  if (post.postType === "draft") return "draft";
  if (post.postType === "queue" || post.queued) return "queue";
  if (post.postType === "archive" || post.postType === "archived")
    return "archive";
  if (
    post.postType === "schedule" ||
    post.nextRunAt ||
    post.when ||
    post.scheduledFor ||
    post.start
  ) {
    return "schedule";
  }
  return "draft";
}

export function getApprovalBoardPostState(post: ApprovalBoardPost) {
  const postType = getApprovalBoardPostType(post);
  switch (postType) {
    case "queue": {
      return POST_STATES.QUEUED;
    }
    case "schedule": {
      return POST_STATES.SCHEDULED;
    }
    case "archive": {
      return POST_STATES.ARCHIVED;
    }
    default: {
      return POST_STATES.DRAFT;
    }
  }
}

export function canSendApprovalPostToQueue(post: ApprovalBoardPost): boolean {
  return (
    getApprovalBoardPostType(post) === "schedule" &&
    !post.past &&
    !post.isSuccess &&
    !post.isPotentialError &&
    !post.isPosting &&
    !post.failReason
  );
}
